import React,{useState} from "react";
import { InputAdornment } from "@mui/material";
import { Label,StyledVisibilityOffIcons,StyledVisibilityOnIcon, StyledTextField } from "./styles";
import InfoIcon from "@mui/icons-material/Info";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
const Input = ({
  labelText,
  id,
  showInfoToolTip,
  tooltipText,
  type,
  inputRef,
  placeholderLabelText,
  ...restInputProps
}) => {
  const [showPassword, setShowPassword] = useState(false);
  const isPasswordInput = type === "password";
  return (
    <div className={`${id}`}>
      <Label htmlFor={id}>
        <span>{labelText}</span>
        {showInfoToolTip && (
          <>
            <Tooltip title={tooltipText}>
              <IconButton>
                <InfoIcon />
              </IconButton>
            </Tooltip>
          </>
        )}
      </Label>
      <StyledTextField
        id={id}
        label={placeholderLabelText}
        ref={inputRef}
        type={isPasswordInput?(showPassword ? 'text':'password'):type}
        variant="outlined"
        autoComplete="off"
        InputProps={{
          endAdornment:  isPasswordInput ? (
            <InputAdornment position="end">
              <IconButton onClick={() => setShowPassword((prev) => !prev)}>
                {showPassword ? <StyledVisibilityOffIcons fill="red" /> : <StyledVisibilityOnIcon   />}
              </IconButton>
            </InputAdornment>
          ):null,
        }}
        {...restInputProps}
      />
    </div>
  );
};

export default Input;
